/* Independent accessible carousel controls. Dawn handles the cart and product forms. */
document.addEventListener('DOMContentLoaded',()=>{
 document.querySelectorAll('.tf-carousel').forEach(section=>{
  const track=section.querySelector('.tf-track');
  section.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>{
   const card=track.firstElementChild;const gap=parseFloat(getComputedStyle(track).gap)||0;
   track.scrollBy({left:(card.getBoundingClientRect().width+gap)*Number(button.dataset.step),behavior:'smooth'});
  }));
  const dots=section.querySelector('.tf-dots');if(dots)track.addEventListener('scroll',()=>{
   const n=Math.round(track.scrollLeft/track.clientWidth);dots.textContent=[...track.children].map((_,i)=>i===n?'●':'·').join(' ');
  });
 });
});

(()=>{const b=document.querySelector('.tf-back-top');if(!b)return;const update=()=>b.hidden=scrollY<500;window.addEventListener('scroll',update,{passive:true});b.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'}));update()})();
